import { Fragment, ReactNode } from 'react'
import Console from '../components/center/modals/console/Console'
import OnBoardschedule from '../components/center/modals/schedule/OnBoardschedule'
import GroundSchedule from '../components/center/modals/schedule/GroundSchedule'
import Telemetry from '../components/center/modals/telemetry/Telemetry'
import FileQueue from '../components/center/modals/files/FileQueue'
import RemoteConnectModal from '../components/center/modals/remote_connect_modal/RemoteConnectModal'
import CustomScheduleModal from '../components/center/modals/schedule/custom-schedule/CustomScheduleModal'
import ScheduleConfirmationModal from '../components/center/modals/schedule/custom-schedule/ScheduleConfirmationModal'
import UploadSchedule from '../components/center/planning/schedule/custom-schedule/UploadSchedule'

interface ModalProviderProps {
  children: ReactNode;
}
const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {

  return (
    <Fragment>
      <Console />
      <OnBoardschedule />
      <GroundSchedule />
      <Telemetry />
      <FileQueue />
      <RemoteConnectModal />

      {/* CUSTOM SCHEDULE MODAL */}
      <CustomScheduleModal />
      <ScheduleConfirmationModal />
      <UploadSchedule/>
      {children}
    </Fragment>
  )
}

export default ModalProvider